<template>
  <div class="title-wrapper">
    <el-tabs v-model="active_name">
      <el-tab-pane label="选择标题" name="choose_title">
        <auxiliary-title ref="choose_title_ref" scene="ChooseTitle" :scene-props="scene_props" @hook:mounted="onTableMounted" />
      </el-tab-pane>
      <el-tab-pane label="批量上传" name="upload_title">
        <auxiliary-title ref="upload_title_ref" scene="UploadTitle" :scene-props="scene_props" />
      </el-tab-pane>
      <!-- 广点通 -->
      <el-tab-pane v-if="[CHANNEL_INTERFACE_TYPE.GDT].includes(init_ops.channel_interface)" label="文案助手" name="helper_title">
        <component :is="`${init_ops.channel_interface}-helper-title`" ref="helper_title_ref" v-bind="{ initOps: init_ops, pageConfig: page_config }" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { data_sharing_mixin } from '@/views/fusion/investment/intelligence-create/mixins/data-sharing';
import { getPageConfig } from '@/views/auxiliary/title/config';
import { CHANNEL_INTERFACE_TYPE } from '@/enums';
import { isNotNullAndUnDef } from '@/utils/is';

export default {
  components: {
    'auxiliary-title': () => import('@/views/auxiliary/title/index.vue'),
    'gdt-helper-title': () => import('./channel-interface/gdt/index.vue'),
  },
  mixins: [data_sharing_mixin],
  props: {
    // 模块表单配置
    formFields: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      CHANNEL_INTERFACE_TYPE,
      assign_selection: [], // 已选中的数据
      init_ops: {}, // 渠道初始化配置数据
      page_config: {}, // 页面配置项
      active_name: 'choose_title', // 当前tabs活跃的面板
    };
  },
  computed: {
    /**
     * 场景的数据
     * @returns {Object} 传递给`auxiliary-title`组件的props数据
     */
    scene_props() {
      const { channel_interface } = this.init_ops;
      return {
        permissions: `title-list-${channel_interface}`,
      };
    },
  },
  created() {
    const form_context = this.local_sharing_data.getFormContext();
    const { init_ops } = form_context.config;
    const { channel_interface } = init_ops;
    Object.assign(this.init_ops, init_ops);
    Object.assign(this.page_config, getPageConfig(`title-list-${channel_interface}`));
  },
  methods: {
    /**
     * 获取分配数据
     * @returns {Array} 标题对象数组或空数组
     */
    async getAssignSelection() {
      try {
        const ref = this.$refs[`${this.active_name}_ref`];
        if (ref.getAssignSelection) {
          return await ref.getAssignSelection();
        }
        const refs = this.$refs[`${this.active_name}_ref`].$children;
        return await refs[0].getAssignSelection();
      } catch (error){
        console.error(error);
        return [];
      }
    },
    /**
     * 初始化表格选中数据
     * @returns {void}
     */
    initRowsSelection() {
      /**
       * 排除不存在ID值的数据项，即只有列表选中的数据才回显
       * 排除标题组件的数据项
       */
      const list = this.formFields.selection_config.list.filter(({ id, title_component_type = '' }) => {
        return isNotNullAndUnDef(id) && title_component_type !== 'component';
      });
      const [ref] = this.$refs[`${this.active_name}_ref`].$children;
      const app_table_ref = ref.$refs.table;
      ref.multiple_selection.splice(0);
      ref.multiple_selection.push(...list);
      app_table_ref.multipleSelection.splice(0);
      app_table_ref.multipleSelection.push(...ref.multiple_selection);
      app_table_ref.multipleSelectionAll.splice(0);
      app_table_ref.multipleSelectionAll.push(...ref.multiple_selection);
    },
    /**
     * 监听表格挂载完成
     * @returns {void}
     */
    onTableMounted() {
      setTimeout(this.initRowsSelection.bind(this), 0);
    },
  },
};
</script>
